import { useQuery } from '@tanstack/react-query';

import { TimeConstants } from '../../../constants/time';
import { StatsigApi } from '../statsig.api';

/**
 * 활성 실험 목록을 조회하는 훅
 * - Statsig 콘솔 API에서 status=active인 실험만 조회
 * - DevTool에서 활성 실험의 variant를 자동으로 표시하기 위해 사용
 */
const useActiveExperimentsQuery = () => {
  return useQuery({
    queryKey: StatsigApi.queryKeys.activeExperiments(),
    queryFn: StatsigApi.findActiveExperiments,
    staleTime: TimeConstants.FIVE_MINUTES,
  });
};

export default useActiveExperimentsQuery;
